import { FileInput } from 'components/Inputs/FileInput';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { PartnerService } from 'services';
import { IPartnerCreate } from 'types/Partner';

import { Grid, Typography } from '@mui/material';
import { useUser } from 'hooks/useUser';

export const ContractForm: FC = () => {
  const { isAdmin } = useUser();
  const { control } = useFormContext<IPartnerCreate>();
  const [partnershipContract, partnerId] = useWatch({
    control,
    name: ['partnershipContract', 'id'],
  });

  /* Hide if user is not admin and hasn't contract file */
  if (!isAdmin && !partnershipContract) {
    return null;
  }

  return (
    <Grid item container md={10}>
      <Grid item xs={12}>
        <Typography variant="button" sx={{ fontSize: 20, fontWeight: 500 }}>
          CONTRATO DE PARCERIA
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FileInput
          id="partnershipContractFile"
          name="partnershipContractFile"
          title="CONTRATO DE PARCERIA"
          fileName={partnershipContract?.name}
          downloadUrl={
            partnershipContract?.name
              ? PartnerService.getPartnerContract(partnerId)
              : undefined
          }
          disableUpload={!isAdmin}
        />
      </Grid>
    </Grid>
  );
};
